import React, { useState } from 'react'
import about from '../images/about_org.jpg'
import CustomInputField from '../components/CustomInputField'
import { Controller, useForm } from "react-hook-form";
import CommonContainer from "../components/CommonContainer";
import {
  CONTACT_REQUIRED_MESSAGE,
  DATE_OF_BIRTH_REQUIRED_MESSAGE,
  DEGREE_REQUIRED_MESSAGE,
  EMAIL_INVALID_MESSAGE,
  EMAIL_REQUIRED_MESSAGE,
  FIRST_NAME_INVALID_MESSAGE,
  FIRST_NAME_REQUIRED_MESSAGE,
  GENDER_REQURIED_MESSAGE,
  LAST_NAME_INVALID_MESSAGE,
  LAST_NAME_REQUIRED_MESSAGE,
  MAX_LENGTH_VALIDATE_MESSAGE,
  MIN_LENGTH_ONE_CHARACTERS,
  MIN_LENGTH_VALIDATE_MESSAGE,
  MIN_LENGTH_VALIDATE_ONE,
  PHONE_REQUIRED_MESSAGE,

} from "../utills/ApplicationConstants";
import { EMAIL_REGEX_PATTERN, ONLY_ALPHABETIC } from "../utills/ApplicationRegex";
import CustomHeading from '../components/CustomHeading';
import CustomRadioButton from '../components/CustomRadioButton';
import CustomDatePicker from '../components/CustomDatePicker';
import dayjs from "dayjs";
import { isValidPhoneNumber } from "react-phone-number-input";
import { FormHelperText } from '@mui/material';
import CustomPhoneInput from '../components/CustomPhoneInput';
import CustomButton from '../components/CustomButton';
import axios from 'axios';
import { BASE_URL, CAREERS } from '../utills/ApplicationRouting';
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';


function Apply() {

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [gender, setGender] = useState("");
  const [dob, setDob] = useState('');
  const [degree, setDegree] = useState('');
  const { token } = useSelector((state) => state.qps);

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      // Check if the file type is PDF
      if (selectedFile.type !== "application/pdf") {
        setErrorMessage("Only PDF files are allowed.");
        setFile(null);
        setFileName("");
        return;
      }
      setFile(selectedFile);
      setFileName(selectedFile.name);
      setErrorMessage("");
    }
  };

  const {
    handleSubmit,
    control,
    reset,
    setError,
    clearErrors,
    formState,
    setValue,
    formState: { errors },
  } = useForm();

  const dobDate = dayjs().subtract(18, "year").endOf("day");

  const handleInputChange = (e) => {
    setFirstName(e.target.value);
  };

  const handleLastNameChange = (e) => {
    setLastName(e.target.value);
  };

  const handleDegreeChange = (e) => {
    setDegree(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleRadioChange = (value) => {
    setGender(value)
  }

  const handleDobChange = (selectedDob) => {
    setDob(selectedDob);
  };

  const onSubmit = (data) => {
    // Check if the phone number is valid
    const storedToken = token;
    const isValidPhoneNumberForCountry = isValidPhoneNumber(data.phoneNumber);
    if (!isValidPhoneNumberForCountry) {
      return;
    }
    // Check if the file is selected
    if (!file) {
      setErrorMessage("Please select a PDF file to upload.");
      return;
    }

    const formData = new FormData();
    formData.append("firstName", data.firstName);
    formData.append("lastName", data.lastName);
    formData.append('dateOfBirth', dob ? dayjs(dob).format("YYYY-MM-DD") : '');
    formData.append("file", file);
    formData.append('contact', data.phoneNumber || "");
    formData.append("qualification", data.degree);
    formData.append("gender", data.gender);
    formData.append("email", data.email);
    console.log("Form DAta:", Object.fromEntries(formData.entries()));

    axios.post(
      `${BASE_URL}${CAREERS}`,
      formData,
      {
        headers: {
          'Authorization': `Bearer ${storedToken}`, // Add the token here
          'Content-Type': 'multipart/form-data', // Ensure the correct content type
        },
      }
    )
      .then((response) => {
        console.log(response);

        if (response.status === 200) {
          console.log("success");
          toast.success(response.data);

          // reset();
          setTimeout(() => {
            navigate("/careers");
          }, 3000);

        }
      })
      .catch((error) => {

        if (error.response && error.response.status !== 200) {

          console.log(error.response.data.message);
          toast.error(error.response.data.message);
          console.log(error.response.data.message);
        }
      });
    // Perform any further action with formData, such as sending it to an API
  };




  return (
    <div>
      <Toaster />
      <div className="relative">
        {/* Background Image */}
        <div className="relative m-auto overflow-hidden mt-4 lg:mt-4 p-2 md:p-12 h-full">
          <div className="absolute inset-0 z-0">
            <img
              src={about}
              alt="Background"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="absolute inset-0 bg-black bg-opacity-50 z-10"></div>

          <div className="relative z-20 container mx-auto py-16 px-6 text-center text-white">
           <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold">Careers</h2>
          </div>
        </div>
        <CommonContainer>
        <div className='mt-16'>
          <p className="text-2xl font-bold text-blue-500 mb-6 text-center">Apply Here</p>
        </div>

        {/* Form Section */}
        <div className="flex justify-center mt-6">
          <div className="w-full md:w-3/5 p-4 md:p-6 rounded-lg shadow-md bg-white">
            <form onSubmit={handleSubmit(onSubmit)}>
              {/* Grid for Input Fields */}
              <section className="grid gap-4 md:grid-cols-2">
                <CustomInputField
                  requiredErrorMessage={FIRST_NAME_REQUIRED_MESSAGE}
                  fieldPattern={ONLY_ALPHABETIC}
                  patternErrorMessage={FIRST_NAME_INVALID_MESSAGE}
                  minLength={2}
                  minLengthErrorMessage={MIN_LENGTH_VALIDATE_MESSAGE}
                  maxLength={60}
                  maxLengthErrorMessage={MAX_LENGTH_VALIDATE_MESSAGE}
                  fieldName="firstName"
                  fieldId="firstName"
                  fieldType="text"
                  fieldLabel="First Name"
                  fieldControl={control}
                  fieldError={errors}
                  fieldRequiredIcon="*"
                  value={firstName}
                  multiline={true}
                  onInput={handleInputChange}
                />

                <CustomInputField
                  fieldName="lastName"
                  requiredErrorMessage={LAST_NAME_REQUIRED_MESSAGE}
                  fieldPattern={ONLY_ALPHABETIC}
                  patternErrorMessage={LAST_NAME_INVALID_MESSAGE}
                  minLength={1}
                  minLengthErrorMessage={MIN_LENGTH_ONE_CHARACTERS}
                  maxLength={60}
                  maxLengthErrorMessage={MAX_LENGTH_VALIDATE_MESSAGE}
                  fieldId="lastName"
                  fieldType="text"
                  fieldLabel="Last Name"
                  fieldControl={control}
                  fieldError={errors}
                  fieldRequiredIcon="*"
                  value={lastName}
                  multiline={true}
                  onInput={handleLastNameChange}
                />

              </section>
              <br />
              <section className="grid gap-4">
                <CustomRadioButton
                  fieldName="gender"
                  requiredErrorMessage={GENDER_REQURIED_MESSAGE}
                  fieldControl={control}
                  fieldError={errors}
                  labelName="Gender"
                  valueOne="Female"
                  labelOne="Female"
                  valueTwo="male"
                  labelTwo="Male"
                  value={gender}
                  onChange={handleRadioChange}
                />
              </section>
              <br />
              <section className="mt-4">
                <CustomDatePicker
                  fieldName="dob"
                  requiredErrorMessage={DATE_OF_BIRTH_REQUIRED_MESSAGE}
                  label="Date of Birth"
                  control={control}
                  maxDate={dobDate}
                  value={dob}
                  onChange={handleDobChange}
                  fieldRequiredIcon="*"
                />
                <br />

                <CustomInputField
                  fieldName="email"
                  requiredErrorMessage={EMAIL_REQUIRED_MESSAGE}
                  fieldPattern={EMAIL_REGEX_PATTERN}
                  patternErrorMessage={EMAIL_INVALID_MESSAGE}
                  fieldId="login-email"
                  fieldType="text"
                  fieldLabel="Email"
                  fieldRequiredIcon="*"
                  fieldControl={control}
                  fieldError={errors}
                  value={email}
                  onInput={handleEmailChange}
                />
                <br />

                <Controller
                  name="phoneNumber"
                  control={control}
                  rules={{
                    required: PHONE_REQUIRED_MESSAGE,
                    validate: {
                      isValidPhoneNumber: (value) =>
                        isValidPhoneNumber(value) || "Please provide valid phone number",
                    },
                  }}
                  render={({ field, fieldState }) => (
                    <>
                      <CustomPhoneInput
                        fieldControl={control}
                        label="Contact"
                        clearErrors={clearErrors}
                        country="US"
                        value={field.value}
                        onChange={(value) => field.onChange(value)}
                        error={fieldState.invalid ? fieldState.error : null}
                        helperText={
                          fieldState.invalid ? fieldState.error?.message : ""
                        }
                      />
                    </>
                  )}
                />
                <br />

                <CustomInputField
                  fieldName="degree"
                  requiredErrorMessage={DEGREE_REQUIRED_MESSAGE}
                  minLength={1}
                  minLengthErrorMessage={MIN_LENGTH_ONE_CHARACTERS}
                  maxLength={60}
                  maxLengthErrorMessage={MAX_LENGTH_VALIDATE_MESSAGE}
                  fieldId="degree"
                  fieldType="text"
                  fieldLabel="Qualification"
                  fieldControl={control}
                  fieldError={errors}
                  fieldRequiredIcon="*"
                  value={degree}
                  multiline={true}
                  onInput={handleDegreeChange}
                />
              </section>

              <br />

              {/* File Upload Section */}
              <section className="mt-4">
                <div className="relative">
                  <input
                    type="file"
                    id="file-upload"
                    className="hidden"
                    accept="application/pdf"
                    onChange={handleFileChange}
                  />
                  <label
                    htmlFor="file-upload"
                    className="cursor-pointer bg-blue-500 text-white py-2 px-4 rounded-md"
                  >

                    Upload Resume (PDF) <span className="text-red-600" >*</span>
                  </label>
                  {fileName && (
                    <span className="block mt-2 text-sm text-gray-600">{fileName}</span>
                  )}
                  {errorMessage && (
                    <span className="block mt-2 text-sm text-red-600">{errorMessage}</span>
                  )}
                </div>
              </section>
              <br />

              {/* Submit Button */}
              <div className="text-center mt-6">
                <CustomButton fieldType="submit" buttonName="Submit" className="w-full md:w-auto" />
              </div>
            </form>
          </div>
        </div>
        <div className="my-24">
          <p className="font-bold text-xl text-center">
            **If Any Queries Please Contact Us -<span className="text-blue-300"> +1 (205)-941-8432  /  +91 8015801544</span>
          </p>
        </div>
        </CommonContainer>
      </div>
      </div>
  );
};

export default Apply;
